import React, { useState } from "react";
import { Container, Button, Group, Text, Title } from "@mantine/core";
import { AppName, Colors, LogoFull } from "../../Lib/Data";
import { PerformRequest } from "../../Lib/usePerformRequest";
import { Endpoints } from "../../Lib/Endpoints";
import { useNavigate, useParams } from "react-router-dom";
import {
  DefaultErrorNotification,
  DefaultSuccessNotification,
} from "../../Lib/Methods";
const RequestDelete: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();

  document.title = `Delete Account :-( | ${AppName}`;

  const email = params.email ?? "";

  const [isRequesting, setRequesting] = useState(false);
  const RequestDeleteEmail = async () => {
    setRequesting(true);
    const r = await PerformRequest({
      method: "DELETE",
      route: Endpoints.GetRequestAccountDeletion(email),
      callback: () => {
        setRequesting(false);
      },
    });
    setRequesting(false);
    if (r && r.status) {
      if (r.status === 200) {
        DefaultSuccessNotification(
          "Account deletion request sent successfully"
        );
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else if (r.status === 404) {
        DefaultErrorNotification("Account not found");
      } else if (r.status === 500) {
        DefaultErrorNotification("Internal server error");
      }
    } else {
      DefaultErrorNotification("Could not delete account");
    }
  };
  return (
    <div className="request-delete-container">
      <Container size="md">
        <div className={"root flex-col align-center"}>
          <img src={LogoFull} alt="" className="logo" />
          <Title className={"title"} c={Colors.OrangeSecondary}>
            Delete Your Account? 😭
          </Title>
          <Text c="dimmed" size="lg" ta="center" className={"description"}>
            You are about to permanently delete your account. This action will
            remove all associated data from our systems, and you will no longer
            have access to any {AppName} services. Please proceed only if you
            are certain.
          </Text>
          <Group justify="center">
            <Button
              loading={isRequesting}
              variant="outline"
              color={Colors.RedPrimary}
              size="md"
              onClick={RequestDeleteEmail}
            >
              Proceed
            </Button>
          </Group>
        </div>
      </Container>
    </div>
  );
};
export default RequestDelete;
